<template>
  <div class="ClientContent">
    <div class="row1">
      <div class="title"><strong>Restitutions Commerciales</strong></div>
    </div>
    <b-row class="responsiveBlock" align-h="between">
      <b-col cols="5" class="responsiveWidht">
        <div class="container_select">
          <span cols="4" class="label">Afficher</span>
          <div cols="4" class="Select"><b-form-select
            v-model="per_page"
            :options="options"
            class="mb-3 responsiveWidht"
            value-field="item"
            text-field="name"
            disabled-field="notEnabled"
            size='sm'
          ></b-form-select></div>
          <span cols="4" class="label">éléments</span>
        </div>
      </b-col>
      <b-col cols="5" fluid="md"  class="responsiveWidht">
        <div class="container_search">
          <span class="label">Recherche : </span
          ><input
            @change="filter"
            @input="filter"
            type="text"
            placeholder="Recherche"
            class="input"
            v-model="search"
          />
        </div>
      </b-col>
    </b-row>
    <div class="content-tab-users">
      <b-table
        responsive
        show-empty
        striped
        id="my-table"
        class="table"
        :items="getFichiers"
        :fields="fields"
        :current-page="page"
        :per-page="per_page"
        sort-icon-left
        no-sort-reset
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        empty-text="Il n'y a aucun enregistrement à afficher"
      >
        <template v-slot:cell(check)="data">
            <b-form-checkbox
        v-model="data.item.check"
        @input="onPreviewClick($event, data.item)"
      ></b-form-checkbox>
        </template>
        <template v-slot:cell(fichier)="data">
          <div class="font-div">
            {{ data.item.fichier }}
          </div>
        </template>
        <template v-slot:cell(cree)="data">
          <div class="font-div">
            {{ data.item.date }} {{ data.item.heure }}
          </div>
        </template>
      </b-table>
      <div class="pagination">
          <button class="btn" @click="DeleteFichiers"> Supprimer la sélection</button>
        <b-pagination
          v-model="page"
          :total-rows="FichiersCount"
          :per-page="per_page"
          align="right"
          size="sm"
          prev-text="Precedent"
          next-text="Suivant"
          aria-controls="my-table"
          @change="pagination"
        ></b-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
export default {
  data() {
    return {
      fields: [
        { key: "check", label: "", sortable: true, tdClass: 'table-col1' },
        { key: "fichier", label: "Fichier", sortable: true,tdClass: 'table-col2' },
        { key: "cree", label: "Créé le", sortable: true,tdClass: 'table-col3' },
      ],
      Fichiers: [
        {
            id:1,
          fichier:'William S',
          date:'22/08/2020',
          heure:'12:41'
        },
        {
            id:2,
          fichier:'Wiiliam',
          date:'16/10/2020',
          heure:'13:41'
        },
      ],
      fichiersToDelete: [],
      page: 1,
      per_page: 1,
      sortBy: "id",
      sortDesc: false,
      search: null,
      selected: 1,
      options: [
        { item: 1, name: 1 },
        { item: 5, name: 5},
        { item: 10, name: 10 },
      ],
      
    };
  },
  methods: {
    ...mapActions(['getAllAlerts']),
    filter() {
      return this.getFichiers.filter(
        (option) =>
          option["first_name"]
            .toLowerCase()
            .startsWith(this.search.toLowerCase()) ||
          option["last_name"]
            .toLowerCase()
            .startsWith(this.search.toLowerCase())
        //.includes(this.search.toLowerCase())
      );
    },
    pagination() {
      console.log("pagination");
    },
    onPreviewClick(value, item) {
        if(value===true){
            this.fichiersToDelete.push(item)
            console.log('add element to table',this.fichiersToDelete)
        }else if(value===false){
            this.fichiersToDelete = this.fichiersToDelete.filter((a) => a.id != item.id);
            console.log('delete element from table',this.fichiersToDelete)
        }  
    },
    DeleteFichiers(){ 
        if(this.fichiersToDelete.length!==0){
            console.log('les fichiers a supprimer',this.fichiersToDelete)
            for(var i=0;i<this.fichiersToDelete.length;i++){
            this.getFichiers=this.getFichiers.filter((a) => a.id != this.fichiersToDelete[i].id)
        }
        this.fichiersToDelete=[]
        }
    }
  },
  computed: {
    ...mapGetters(['getFichiers']),
    FichiersCount() {
      return this.getFichiers.length;
    },
  },
  mounted(){
    this.getAllAlerts()
  }
};
</script>
<style scoped lang="scss">
// @import "node_modules/bootstrap/scss/bootstrap.scss";
// @import "node_modules/bootstrap-vue/src/index.scss";
.ClientContent {
  width: 100%;
  display: inline;
  padding: 5px;
  margin: 15px;
  position: relative;
  .row1 {
    width: 100%;
    .title {
      width: 100%;
      color: #068596ba;
      font-weight: bold;
      font-size: 23px;
      margin-top: 0px;
      margin-bottom: 20px;
    }
    .Element {
      color: #8c9a9c;
      margin-top: 13px;
      margin-bottom: 13px;
    }
    .pagination {
      margin-top: 13px;
      margin-bottom: 13px;
      text-align: right;
      
    }
  }
  .container_search {
    width: 100%;
    display: flex;
    .label {
      color: #949d9e;
      font-size: 18px;
      width: 35%;
    }
    .input {
      color: #b5bcbd;
      background-color: white;
      border: 1px solid #b0b8b9;
      padding: 8px;
      border-radius: 5px;
      width: 65%;
      height: 30px;
      &:focus {
        outline: 0;
      }
      &::placeholder {
        color: #b5bcbd;
      }
    }
  }
  .container_select{
      width: 100%;
      display: flex;
    .label {
      color: #949d9e;
      font-size: 18px;
      margin-right: 3px;
      margin-left: 3px;
    }
  }
  .content-tab-users {
    padding-top: 4px;
    .sortloading {
      padding-bottom: 20px;
    }
    table {
      width: 100%;
      text-align: center;
      margin-bottom: 1rem;
      color: #212529;
      border: 0;
      border: 1px solid #dfe1e2;
      margin-top: -8px;
      font-size: 12px;
         
      tbody {
        .font-div,
        .font-p {
          font-size: 15px;
          margin-top: 0;
          margin-bottom: 0;
          &.font-div {
            text-transform: capitalize;
          }
        }
        .name {
          text-transform: capitalize;
        }
      }
    }
  }
}
@media screen and (max-width: 1024px) {
  .ClientContent {
    .container_search {
        .label{
            font-size: 15px;
            padding-top:4px;
            width: 41%;
        }
        .input{
            width: 59%;
        }  
    }
    .container_select{
        .label{
            font-size: 16px;
            padding-top:3px;
        }
    }
  }
}
@media screen and (max-width: 425px) {
  .ClientContent {
    width: 100%;
    .responsiveBlock {
      display: inline;
      font-size: 17px;
    }
    .responsiveWidht {
      max-width: 100%;
    }
    .content-tab-users {
      .pagination {
        display: inline-block;
        justify-content: space-between;
        justify-items: center;
        width: 100%;
        text-align: center;
      }
    }
  }
}
</style>
<style lang="scss">
.table-col1{
    width: 20%;
    min-width: 20px;
}
.table-col2{
    width: 50%;
    min-width: 100px;
}
.table-col3{
    width: 30%;
    min-width: 150px;
}
.content-tab-users {
  .table.b-table.table-sm > thead > tr > [aria-sort].b-table-sort-icon-left,
  .table.b-table.table-sm > tfoot > tr > [aria-sort].b-table-sort-icon-left {
    background-position: left calc(3.3rem / 2) center;
    padding-left: calc(1.3rem + -0.35em);
  }
  .table {
    width: 100%;
    border-collapse: collapse;
    font-size: 12px;
  }
  .table-striped tbody tr:nth-of-type(odd) {
    background-color: rgba(0, 0, 0, 0.05);
  }
  .table.b-table > thead > tr > [aria-sort].b-table-sort-icon-left,
  .table.b-table > tfoot > tr > [aria-sort].b-table-sort-icon-left {
    background-position: right calc(0.75rem / 2) center;
    outline: 0;
    min-width: 100px;
    border: 1px solid #e9eaeb;
  }
  .table.b-table > thead > tr > [aria-sort="ascending"],
  .table.b-table > tfoot > tr > [aria-sort="ascending"] {
    background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='101' height='101' view-box='0 0 101 101' preserveAspectRatio='none'%3e%3cpath fill='black' d='M51 1l25 23 24 22H1l25-22z'/%3e%3cpath fill='black' opacity='.3' d='M51 101l25-23 24-22H1l25 22z'/%3e%3c/svg%3e");
  }
  .table.b-table > thead > tr > [aria-sort="descending"],
  .table.b-table > tfoot > tr > [aria-sort="descending"] {
    background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='101' height='101' view-box='0 0 101 101' preserveAspectRatio='none'%3e%3cpath fill='black' opacity='.3' d='M51 1l25 23 24 22H1l25-22z'/%3e%3cpath fill='black' d='M51 101l25-23 24-22H1l25 22z'/%3e%3c/svg%3e");
  }
  .table.b-table > thead > tr > [aria-sort],
  .table.b-table > tfoot > tr > [aria-sort] {
    cursor: pointer;
    background-repeat: no-repeat;
    background-size: 0.65em 1em;
  }
  .table.b-table > thead > tr > [aria-sort="none"],
  .table.b-table > tfoot > tr > [aria-sort="none"] {
    background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='101' height='101' view-box='0 0 101 101' preserveAspectRatio='none'%3e%3cpath fill='black' opacity='.3' d='M51 1l25 23 24 22H1l25-22zM51 101l25-23 24-22H1l25 22z'/%3e%3c/svg%3e");
  }

  .table tbody td {
    border-bottom: 1px solid #dee2e6;
    padding: 5px;
    font-size: 12px;
    border: 1px solid #e9eaeb;
  }
  .table thead th {
    vertical-align: middle;
    background-color: white;
    color: #5f6263;
    border-bottom: 1px solid #dee2e6;
    border-top: 1px solid #dee2e6;
    div {
     text-align: left;
     padding-left: 10px;
    }
    span {
      width: 50%;
    }
  }
  .table thead tr th {
    padding: 0px;
    padding-top: 10px;
    padding-bottom: 10px;
    outline: 0;
  }
  .table tbody td {
    color: #8c9a9c;
  }
  .table-sm th,
  .table-sm td {
    vertical-align: middle;
    border: 1px solid #dee2e6;
  }
  .pagination {
    display: flex;
    justify-content: space-between;
    justify-items: center;
    width: 100%;
    padding: 8px;
    color: #979292;
    .btn {
            background-color: #068596fa;
            color: white;
            border: 0px;
            width: 180px;
            height: 30px;
            margin: 2px;
            font-size: 13px;
            padding: 1px;
            &:hover {
              background-color: #ff8c00;
            }
          }
    ul {
        
      li {
        padding: 10px;
        button {
          border-radius: 5px;
          color: #979292;
          background-color: #e6e6e6;
          border: none;
          outline: 0;
          padding: 10px;
          &:focus {
            background-color: #c9c4c4;
          }
        }
      }
    }
  }

}
@media screen and (max-width: 425px) {
  .content-tab-users .pagination ul li {
    padding: 3px;
    display: inline;
  }
}
</style>
